import styled from 'styled-components';

export const articlesListTitle = { marginBottom: 32 };

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
